import { render } from "./OptOut.vue?vue&type=template&id=b9ac7f16&scoped=true"
import script from "./OptOut.vue?vue&type=script&lang=js"
export * from "./OptOut.vue?vue&type=script&lang=js"

import "./OptOut.vue?vue&type=style&index=0&id=b9ac7f16&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ac7f16"]])

export default __exports__